import React from 'react';
import { observer, inject } from 'mobx-react';
import PageTitle from '../../components/PageTitle/PageTitle';
import FormInputLabel from '../../components/FormInputLabelView';
import { Link } from 'react-router-dom';
import './styles/badge.css';
import { withTranslation } from 'react-i18next';
import {
  withStyles,
  Grid,
  DialogActions,
  Dialog,
  Button,
  DialogContent,
  DialogTitle,
  Paper,
  Select,
  MenuItem,
  TextField,
  Typography,
  Divider,
  Popover,
} from '@material-ui/core';
import * as Icons from '@material-ui/icons';
import Swal from 'sweetalert2';
import Loader from '../../components/Loader/LoaderView';
import { clearLocalStorage } from '../../utils/common';
import CustomFooter from '../../components/Table/CustomFooter';
import WarningForm from '../wizard/components/Dialog/WarningForm';
import FixedEmergencyDeviceView from '../wizard/components/Dialog/FixedEmergencyDeviceView';

class MapsPosition extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tenantId: null,
      loading: false,
      dialogAddopen: false,
      dialogAddDeviceOpened: false,
      disable: false,
      routers: [],
      routerPoint: {
        id: null,
        x: 0,
        y: 0,
        name: null,
      },
      limit: 100,
      tab: 0,
      devicesInMap: [],
      devicePoint: {
        id: null,
        mapId: null,
        position: {
          x: 0,
          y: 0,
        },
        place: null,
        name: null,
      },
      fixedEmergencyDevices: [],
      typingTimeout: 0,
      searchText: '',
      dialogWarningForm: {
        id: null,
        mapId: null,
        name: null,
        open: false,
      },
      headerTitle: '',
      subTitle: '',
    };
  }

  async componentDidMount() {
    const mapPath = this.props.location.pathname.replace('/app/maps/', '');
    const mapId = Number(mapPath.replace('/manage', ''));

    await this.props.maps._getMapById(mapId);
    const { map } = this.props.maps.toJS();
    if (map) {
      this.setState({ tenantId: map.tenantId });
      await this.props.router.getRouterList(0, this.state.limit, null, null, null, [map.tenantId]);
    }

    this.props.router.setData('search', null, false);
    await this.props.locations.getLocationList(0, 0);

    const routersInMap = await this.props.router.findByMapId(mapId);
    const routers = (routersInMap || []).map((val) => {
      let data = {};
      data.id = val.id;
      data.name = val.name;
      data.place = val.place;
      data.serial = val.serial;
      data.referenceNumber = val.referenceNumber;
      data.anchorEl = null;
      if (val.position) {
        let position = JSON.parse(val.position);
        data.x = position.x;
        data.y = position.y;
      } else {
        data.x = 0;
        data.y = 0;
      }
      return data;
    });
    this.setState({ routers });
    this.initFixedEmergencyDevices(mapId);
  }

  async initFixedEmergencyDevices(mapId) {
    const { tenantId } = this.state;
    const queryOption = {
      tenantIds: JSON.stringify([tenantId]),
      filterOutStatus: [],
      requiredMapIdNull: false,
      mapIds: JSON.stringify([mapId]),
    };
    let devices = await this.props.device.getFixedEmergencyDevices(queryOption);
    devices = (devices || []).map((d) => {
      let data = {};
      data.id = d.id;
      data.mapId = d.mapId;
      data.name = d.name;
      data.place = d.place;
      data.position = d.mapPosition;
      return data;
    });
    this.setState({ devicesInMap: devices });
  }

  addRouter(e) {
    const x = e.nativeEvent.offsetX;
    const y = e.nativeEvent.offsetY;
    this.setState({
      ...this.state,
      dialogAddopen: true,
      routerPoint: {
        ...this.state.routerPoint,
        id: null,
        x: x / 10,
        y: y / 10,
        name: null,
      },
    });
  }

  handleAddDevice = async (e) => {
    const x = e.nativeEvent.offsetX;
    const y = e.nativeEvent.offsetY;
    this.setState({
      ...this.state,
      dialogAddDeviceOpened: true,
      devicePoint: {
        ...this.state.devicePoint,
        id: null,
        mapId: null,
        position: {
          x: x / 10,
          y: y / 10,
        },
        name: null,
      },
    });

    this.setFiexedEmergencyData();
  };

  handleDeviceChange = (e) => {
    const id = +e.target.value;
    const mapPath = this.props.location.pathname.replace('/app/maps/', '');
    const mapId = Number(mapPath.replace('/manage', ''));
    const { fixedEmergencyDevices } = this.state;
    const device = fixedEmergencyDevices.data.find((val) => val.id === id);

    if (device) {
      this.setState({
        devicePoint: {
          ...this.state.devicePoint,
          id,
          mapId,
          place: device.place,
          name: device.name,
        },
        disable: true,
      });
    }
  };

  handleHoverDevice(id, task) {
    let devices = this.state.devicesInMap;
    if (task === 'clear') {
      (devices || []).map((val) => {
        val.hover = false;
        return val;
      });
    } else {
      (devices || []).map((val) => {
        if (val.id === id) {
          val.hover = true;
        } else {
          val.hover = false;
        }
        return val;
      });
    }
    this.setState({
      ...this.state,
      devicesInMap: devices,
    });
  }

  handleDeleteDevice = () => {
    const { dialogWarningForm } = this.state;
    const devices = [...this.state.devicesInMap];
    devices.forEach((d) => {
      if (d.id === dialogWarningForm.id) {
        d.mapId = null;
        d.position = null;
        d.name = null;
        d.place = null;
      }
    });
    this.setState({
      ...this.state,
      devicesInMap: devices,
    });

    const { fixedEmergencyDevices } = this.state;
    (fixedEmergencyDevices.data || []).forEach((device) => {
      if (device.id === dialogWarningForm.id) {
        device.mapId = null;
      }
    });
    this.handleCloseWarningForm();
  };

  handleCloseDeviceList = async () => {
    this.setState({
      searchText: '',
      dialogAddDeviceOpened: false,
      disable: false,
      fixedEmergencyDevices: [],
    });
    this.props.device.resetData();
  };

  handleSubmitDeviceList = async () => {
    const { devicePoint, devicesInMap } = this.state;
    let devices = devicesInMap.filter((d) => d.id !== devicePoint.id);
    devices.push(devicePoint);

    this.setState({
      dialogAddDeviceOpened: false,
      devicesInMap: devices,
      searchText: '',
      fixedEmergencyDevices: [],
      disable: false,
    });
    this.props.device.resetData();
  };

  handleSaveDevices = async () => {
    const { t } = this.props;
    const { devicesInMap } = this.state;
    const mapPath = this.props.location.pathname.replace('/app/maps/', '');
    const mapId = Number(mapPath.replace('/manage', ''));

    try {
      const result = await this.props.device.assignDevicesToMap(devicesInMap, mapId);
      if (result.statusCode === 200) {
        Swal.fire({
          html: `<h4>${t('point_device_success')}`,
          type: 'success',
        }).then(async (resultSuccess) => {
          if (resultSuccess.value) {
            this.props.history.push('../../maps');
          } else {
            Swal.fire({
              html: `<h4>${t('failed_to_point_device')}`,
              type: 'error',
            });
          }
        });
      }
    } catch (e) {
      if (e.statusCode === 401) {
        clearLocalStorage();
        window.location.href = '/login';
      } else {
        Swal.fire({
          html: `<h4>'${t('failed_to_point_router')}'`,
          type: 'error',
        });
      }
    }
  };

  handleSearchDevice = (task, value) => {
    if (this.state.typingTimeout) {
      clearTimeout(this.state.typingTimeout);
    }

    this.setState({
      searchText: value,
      typingTimeout: setTimeout(() => {
        this.props.device.setData('search', value, false);
        this.setFiexedEmergencyData();
      }, 1000),
    });
  };

  setFiexedEmergencyData = async () => {
    let { offset, search } = this.props.device.toJS();
    const queryOptionFreeDevice = {
      offset: offset,
      limit: this.state.limit,
      tenantIds: JSON.stringify([this.state.tenantId]),
      filterOutStatus: [],
      requiredMapIdNull: true,
      search: search,
    };
    const allDevices = await this.props.device.getFixedEmergencyDevices(queryOptionFreeDevice);
    if (allDevices && allDevices.data.length > 0) {
      allDevices.data.forEach((d) => {
        (this.state.devicesInMap || []).forEach((device) => {
          if (d.id === device.id) {
            d.mapId = device.mapId;
          }
        });
      });
    }
    this.setState({ fixedEmergencyDevices: allDevices });
  };

  handleChangeDevicePage = async (value) => {
    this.props.device.setData('offset', value * this.state.limit, false);
    await this.setFiexedEmergencyData();
  };

  handleHoverRouter(id, task, event) {
    let routers = this.state.routers;
    if (task === 'clear') {
      routers.map((val) => {
        val.hover = false;
        return val;
      });
    } else {
      routers.map((val) => {
        if (val.id === id) {
          val.hover = true;
        } else {
          val.hover = false;
        }
        return val;
      });
    }
    this.setState({
      ...this.state,
      routers: routers,
    });
  }

  handleDeleteRouter(value) {
    const { t } = this.props;
    Swal.fire({
      html: `<h4>${t('confirm_remove_router')} "${value.place}" ?`,
      type: 'warning',
      confirmButtonText: `${t('remove')}`,
      showCancelButton: true,
      reverseButtons: true,
      customClass: {
        container: 'my-swal',
      },
      cancelButtonText: `${t('cancel')}`,
    }).then(async (result) => {
      if (result.value) {
        this.props.router.setMapId(value.id);
        const routers = this.state.routers;
        let filterRouter = routers.filter((val) => val.id !== value.id);
        this.setState({
          ...this.state,
          routers: filterRouter,
        });
      }
    });
  }

  goBack() {
    window.location.href = '/app/maps';
  }

  handleClose = async () => {
    this.setState((data) => {
      data.dialogAddopen = false;
      return data;
    });
    this.props.router.setData('search', null, false);
    await this.props.router.getRouterList(0, this.state.limit, null, null, null, [this.state.tenantId]);
  };

  handleSubmit = async () => {
    const routerPoint = this.state.routerPoint;
    this.state.routers.push(routerPoint);
    this.setState((prevState) => {
      prevState.dialogAddopen = false;
      prevState.disable = false;
      return prevState;
    });
    this.props.router.setData('search', null, false);
    await this.props.router.getRouterList(0, this.state.limit, null, null, null, [this.state.tenantId]);
  };

  handleSaveMapPosition = async () => {
    const { t } = this.props;
    const mapPath = this.props.location.pathname.replace('/app/maps/', '');
    const mapId = Number(mapPath.replace('/manage', ''));
    try {
      const result = await this.props.maps.saveRouterPosition(this.state.routers, mapId);
      if (result.statusCode === 200) {
        Swal.fire({
          html: `<h4>${t('point_router_success')}`,
          type: 'success',
        }).then(async (resultSuccess) => {
          if (resultSuccess.value) {
            this.props.history.push('../../maps');
          } else {
            Swal.fire({
              html: `<h4>${t('failed_to_point_router')}`,
              type: 'error',
            });
          }
        });
      }
    } catch (e) {
      if (e.statusCode === 401) {
        clearLocalStorage();
        window.location.href = '/login';
      } else {
        Swal.fire({
          html: `<h4>${t('failed_to_point_router')}`,
          type: 'error',
        });
      }
    }
  };

  onRouterChange = (e) => {
    const id = e.target.value;
    const { routerList } = this.props.router.toJS();
    const router = routerList.data.find((val) => val.id === id);
    if (router) {
      this.setState((prevState) => {
        prevState.routerPoint.id = id;
        prevState.routerPoint.name = router.name;
        prevState.routerPoint.place = router.place;
        prevState.disable = true;
        return prevState;
      });
    } else {
      this.setState((prevState) => {
        prevState.routerPoint.id = null;
        prevState.routerPoint.name = null;
        prevState.routerPoint.place = null;
        prevState.disable = false;
        return prevState;
      });
    }
  };

  handleSearch = async (task, value) => {
    this.props.router.setData('offset', 0, false);
    await this.props.router.setData(task, value);
    this.setState((prevState) => {
      prevState.routerPoint.id = null;
      prevState.routerPoint.name = null;
      prevState.routerPoint.place = null;
      prevState.disable = false;
      return prevState;
    });
  };

  handleChangeRowsPerPage = (value) => {
    this.props.router.setData('limit', value);
  };

  handleChangePage = (value) => {
    this.props.router.setData('offset', value * this.state.limit);
  };

  handlePopoverOpen = (event, id) => {
    let routers = this.state.routers;

    this.setState((prevState) => ({
      routers: prevState.routers.map((router) =>
        router.id === id ? { ...router, anchorEl: event.currentTarget } : router
      ),
    }));

    routers.map((val) => {
      if (val.id === id) {
        val.hover = true;
      } else {
        val.hover = false;
      }
      return val;
    });
  };

  handlePopoverClose = (id) => {
    let routers = this.state.routers;

    this.setState((prevState) => ({
      routers: prevState.routers.map((router) =>
        router.id === id ? { ...router, anchorEl: null } : router
      ),
    }));

    routers.map((val) => {
      val.hover = false;
      return val;
    });
  };

  handleChangeTab = (tab) => {
    this.setState({
      tab,
    });
  };

  handleOpendWarningForm = (value, task) => {
    const { t } = this.props;
    const name = value.place ? value.place : value.name;
    const subTitleRouter = t('wizard_router_delete_subtitle').replace('x', name);
    const subTitleDevice = t('wizard_device_delete_subtitle').replace('x', name);
    this.setState({
      headerTitle: task === 'router' ? t('wizard_router_delete') : t('wizard_device_delete'),
      subTitle: task === 'router' ? subTitleRouter : subTitleDevice,
      dialogWarningForm: {
        id: value.id,
        mapId: value.mapId,
        open: true,
        name,
      },
    });
  };

  handleCloseWarningForm = () => {
    this.setState({
      headerTitle: '',
      subTitle: '',
      dialogWarningForm: {
        ...this.state.dialogWarningForm,
        mapId: null,
        open: false,
      },
    });
  };

  render() {
    const { classes, t } = this.props;
    const { locations } = this.props.locations.toJS();
    let { routerList, search, loading } = this.props.router.toJS();
    const { map } = this.props.maps.toJS();
    const count = routerList.data ? routerList.pagination.count : 0;
    const page = routerList.data ? routerList.pagination.page - 1 : 0;

    (routerList.data || []).map((router) => {
      router.routerStandby = (this.state.routers || []).find((val) => val.id === router.id) ? false : true;
      return router;
    });
    routerList.data = (routerList.data || []).filter(
      (router) => router.routerStandby === true && router.mapId === null,
    );

    return (
      <React.Fragment>
        <Loader loading={loading} />
        <Paper className={classes.paper}>
          <PageTitle title={t('view_a_map')} />
          <Grid container spacing={16} className={classes.wrapContain}>
            <Grid item xs={12} sm={6}>
              <Grid container spacing={16}>
                <Grid item xs={12} sm={4}>
                  <FormInputLabel label={t('name')} align='right' />
                </Grid>
                <Grid item xs={12} sm={8}>
                  <TextField
                    id='name'
                    name='name'
                    fullWidth
                    value={map.name}
                    variant='outlined'
                    margin='dense'
                    disabled
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Grid container spacing={16}>
                <Grid item xs={12} sm={4}>
                  <FormInputLabel label={t('location')} align='right' />
                </Grid>
                <Grid item xs={12} sm={8}>
                  <Paper className={`${classes.root} selectInput ${classes.spaceTop}`}>
                    <Select
                      value={map.locationId}
                      inputProps={{
                        name: 'locationId',
                        id: 'locationId',
                      }}
                      disabled
                    >
                      {(locations.data || []).map((val) => (
                        <MenuItem fullwidth='true' key={val.id} value={val.id}>
                          {`${val.name || ''}`}
                        </MenuItem>
                      ))}
                    </Select>
                  </Paper>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid container style={{ marginTop: 10, paddingLeft: '15vw', marginBottom: '-60px' }}>
            <Button
              id='router-tab'
              variant='outlined'
              color='primary'
              onClick={() => this.handleChangeTab(0)}
              style={{
                marginRight: 10,
                borderRadius: 8,
                backgroundColor: this.state.tab === 0 ? '#E5F9F6' : '#FFFFFF',
              }}
            >
              <svg width='20' height='20' viewBox='0 0 20 20'>
                <use xlinkHref={`/images/map.svg#router`} />
              </svg>
              <div style={{ marginLeft: 5 }}>{t('router')}</div>
            </Button>
            <Button
              id='device-tab'
              variant='outlined'
              color='primary'
              onClick={() => this.handleChangeTab(1)}
              style={{
                borderRadius: 8,
                backgroundColor: this.state.tab === 1 ? '#E5F9F6' : '#FFFFFF',
              }}
            >
              <svg width='20' height='20' viewBox='0 0 20 20'>
                <use xlinkHref={`/images/map.svg#sos-device`} />
              </svg>
              <div style={{ marginLeft: 5 }}>{t('device')}</div>
            </Button>
          </Grid>
          {this.state.tab === 0 ? (
            <Grid container spacing={16}>
              <Grid item xs={12}>
                <div
                  className={classes.boxImage}
                  style={{
                    background: `url(${map.imgUrl || ''}) center center no-repeat`,
                  }}
                  id='mapsposition'
                >
                  {(this.state.routers || []).map((val) => {
                    const open = Boolean(val.anchorEl);
                    return (
                      <div
                        style={{ textAlign: 'center' }}
                        key={val.id}
                        onClick={() => this.handleDeleteRouter(val)}
                        onMouseEnter={(e) => this.handlePopoverOpen(e, val.id)}
                        onMouseLeave={() => this.handlePopoverClose(val.id)}
                      >
                        <div
                          className={classes.router}
                          style={{
                            left: `${val.x - 1.5}%`,
                            top: `${val.y - 1.5}%`,
                          }}
                        >
                          <Icons.Router className={classes.iconActivity} fontSize='large' />
                          {val.hover && <Icons.Clear className={classes.iconClaer} />}
                        </div>
                        <div
                          className={classes.nameRount}
                          style={{
                            left: `${val.x - 1.5}%`,
                            top: `${val.y - 1.5}%`,
                          }}
                        >
                          <label className='badge badge-primary'>{val.place}</label>
                        </div>
                        <Popover
                          className={classes.popover}
                          classes={{
                            paper: classes.paper,
                          }}
                          id={val.id}
                          open={open}
                          anchorEl={val.anchorEl}
                          onClose={() => this.handlePopoverClose(val.id)}
                          anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'center',
                          }}
                          transformOrigin={{
                            vertical: 'top',
                            horizontal: 'center',
                          }}
                        >
                          <Typography style={{ padding: 2 }}>{t('serial')}: {val.serial}</Typography>
                          <Typography style={{ padding: 2 }}>{t('reference_number')}: {val.referenceNumber}</Typography>
                        </Popover>
                      </div>
                    );
                  })}
                  <div className={classes.areaPoint} onClick={this.addRouter.bind(this)}></div>
                </div>
              </Grid>
              <Grid item xs={12}>
                <div className={classes.buttons}>
                  <Link to='/app/maps'>
                    <Button className={classes.button}>{t('back')}</Button>
                  </Link>
                  <Button
                    variant='contained'
                    color='primary'
                    onClick={() => this.handleSaveMapPosition()}
                    className={classes.button}
                  >
                    {t('save')}
                  </Button>
                </div>
              </Grid>
            </Grid>
          ) : (
            <Grid container spacing={16}>
              <Grid item xs={12}>
                <div
                  className={classes.boxImage}
                  style={{
                    background: `url(${map.imgUrl || ''}) center center no-repeat`,
                  }}
                  id='mapsposition'
                >
                  {(this.state.devicesInMap || []).map((val, i) => (
                    <div
                      style={{
                        textAlign: 'center',
                        display: val.position ? 'block' : 'none',
                      }}
                      key={i}
                      onClick={() => this.handleOpendWarningForm(val, 'device')}
                      onMouseOver={() => this.handleHoverDevice(val.id, 'hover')}
                      onMouseOut={() => this.handleHoverDevice(val.id, 'clear')}
                    >
                      <div
                        className={classes.sosDevice}
                        style={{
                          left: val.position ? `${val.position.x - 1.5}%` : 0,
                          top: val.position ? `${val.position.y - 1.5}%` : 0,
                        }}
                      >
                        <svg width='45' height='45' viewBox='0 0 84 83'>
                          <use xlinkHref={`/images/sos-v4.svg#fixed`} />
                        </svg>
                        {val.hover && <Icons.Clear className={classes.iconClaerDevice} />}
                      </div>
                      <div
                        className={classes.nameRount}
                        style={{
                          left: val.position ? `${val.position.x - 1.5}%` : 0,
                          top: val.position ? `${val.position.y - 1.5}%` : 0,
                        }}
                      >
                        <label className='badge badge-error-sos'>{val.place ? val.place : val.name}</label>
                      </div>
                    </div>
                  ))}
                  <div className={classes.areaPoint} onClick={this.handleAddDevice.bind(this)}></div>
                </div>
              </Grid>
              <Grid item xs={12}>
                <div className={classes.buttons}>
                  <Link to='/app/maps'>
                    <Button className={classes.button}>{t('back')}</Button>
                  </Link>
                  <Button
                    variant='contained'
                    color='primary'
                    onClick={this.handleSaveDevices}
                    className={classes.button}
                  >
                    {t('save')}
                  </Button>
                </div>
              </Grid>
            </Grid>
          )}
        </Paper>

        <Dialog
          onClose={this.handleClose}
          open={this.state.dialogAddopen}
          aria-labelledby='form-dialog-title'
          maxWidth='sm'
          fullWidth
        >
          <DialogTitle className='header' id='form-dialog-title'>
            {t('select_router')}
          </DialogTitle>
          <DialogContent style={{ overflow: 'hidden' }}>
            <Grid container>
              {routerList.data.length === 0 && search === null ? (
                <Grid item xs={12}>
                  <div>
                    <Typography variant='subtitle1'>
                      {t('not_found_router')}
                      <Link to='/app/routers/create'>
                        <Button color='primary' variant='outlined' className={classes.button}>
                          {t('create_router')}
                        </Button>
                      </Link>
                    </Typography>
                    <Divider className={classes.divider} />
                  </div>
                </Grid>
              ) : (
                <Grid item xs={12} className='deviceSelect'>
                  <Grid>
                    <TextField
                      required
                      id='search'
                      name='search'
                      fullWidth
                      value={search || ''}
                      onChange={(e) => this.handleSearch('search', e.target.value)}
                      variant='outlined'
                      margin='dense'
                      placeholder={t('search')}
                    />
                  </Grid>
                  <Paper className={`${classes.root} selectInput`}>
                    <Select
                      value={this.state.routerPoint.id || 0}
                      onChange={(e) => {
                        this.onRouterChange(e);
                      }}
                      inputProps={{
                        name: 'assing-router',
                        id: 'assing-router',
                      }}
                    >
                      <MenuItem fullwidth='true' key={0} value={0}>
                        {t('please_select_router')}
                      </MenuItem>
                      {(routerList.data || []).map((val) => (
                        <MenuItem fullwidth='true' key={val.id} value={val.id}>
                          {`${val.place || 'router name'} (${val.serial || 'serial number'})`}
                        </MenuItem>
                      ))}
                    </Select>
                  </Paper>
                  <div style={{ position: 'relative', marginBottom: 10 }}>
                    <div style={{ position: 'absolute', right: '-30px' }}>
                      <CustomFooter
                        count={count}
                        page={page}
                        rowsPerPage={this.state.limit}
                        rowsPerPageOptions={[]}
                        changeRowsPerPage={this.handleChangeRowsPerPage}
                        changePage={this.handleChangePage}
                      />
                    </div>
                  </div>
                </Grid>
              )}
            </Grid>
          </DialogContent>
          <DialogActions>
            <Grid item xs={12}>
              <div className={classes.buttons}>
                <Button onClick={this.handleClose} color='default'>
                  {t('cancel')}
                </Button>
                {routerList.data.length === 0 && search === null ? (
                  ''
                ) : (
                  <Button
                    onClick={this.handleSubmit}
                    color='primary'
                    className={classes.button}
                    disabled={!this.state.disable}
                  >
                    {t('add')}
                  </Button>
                )}
              </div>
            </Grid>
          </DialogActions>
        </Dialog>

        <FixedEmergencyDeviceView
          open={this.state.dialogAddDeviceOpened}
          devices={this.state.fixedEmergencyDevices}
          devicePoint={this.state.devicePoint}
          limit={this.state.limit}
          search={this.state.searchText}
          disable={this.state.disable}
          handleClose={this.handleCloseDeviceList}
          handleChange={this.handleDeviceChange}
          handleSearch={this.handleSearchDevice}
          handleSubmit={this.handleSubmitDeviceList}
          changePage={this.handleChangeDevicePage}
        />

        <WarningForm
          open={this.state.dialogWarningForm.open}
          handleSubmitForm={this.state.tab === 0 ? this.handleDeleteRouter : this.handleDeleteDevice}
          handleCloseForm={this.handleCloseWarningForm}
          cancelButtonText={t('no')}
          confirmButtonText={t('confirm')}
          headerTitle={this.state.headerTitle}
          subTitle={this.state.subTitle}
        />
      </React.Fragment>
    );
  }
}

const styles = (theme) => ({
  spaceTop: {
    marginTop: '10px',
  },
  paper: {
    padding: '24px',
    margin: '30px',
    // padding: theme.spacing.unit,
  },
  wrapContain: {
    padding: 20,
  },
  boxImage: {
    position: 'relative',
    width: '1000px',
    height: '1000px',
    backgroundSize: 'contain !important',
    backgroundColor: 'gray',
    border: 'solid 1px',
    margin: '0 auto 0',
    marginTop: '100px',
  },
  iconActivity: {
    color: '#000',
  },
  router: {
    textAlign: 'center',
    width: '42px',
    height: '42px',
    background: 'rgba(3,149,136,0.8)',
    position: 'absolute',
    borderRadius: '50%',
    cursor: 'pointer',
    '&:hover, &:focus': {
      background: 'rgba(255,0,0,0.8)',
    },
  },
  sosDevice: {
    textAlign: 'center',
    position: 'absolute',
    borderRadius: '50%',
    cursor: 'pointer',
  },
  areaPoint: {
    width: '100%',
    height: ' 100%',
    cursor: 'copy',
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    marginLeft: theme.spacing.unit * 1,
  },
  iconClaer: {
    color: 'black',
    marginTop: '-5px',
    marginLeft: '-2px',
    position: 'absolute',
  },
  iconClaerDevice: {
    color: 'black',
    marginTop: '-50px',
    marginLeft: '12px',
    position: 'absolute',
  },
  nameRount: {
    width: '300px',
    position: 'absolute',
    textAlign: 'center',
    marginTop: '48px',
    marginLeft: '-128px',
  },
  divider: {
    marginTop: '20px',
  },
  popover: {
    pointerEvents: 'none',
  },
});

export const page = inject('maps', 'router', 'locations', 'device', 'wizard')(observer(MapsPosition));
export const translation = withTranslation()(page);
export default withStyles(styles, { withTheme: true })(translation);
